module.exports = __webpack_public_path__ + "img/pethouse11.a9391729.jpg";